/* esm.sh - applesauce-core@5.2.0/dist/helpers/relay-selection */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/relay-selection.mjs";
